import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ButtonSpan } from "Components/Button";
import Modal from "Components/Modal";
import { companyUnload, fetchCountries } from "../../redux/actions";
import MinimalCompanyForm from "./MinimalCompanyForm";
import { fetchIndustries } from "../../modules/industries";
import { agencyCompanyDomains } from "../../services/companyService/agencyCompanyDomains";
import Loading from "../Loading";
import { Toggle } from "../Form";
import { stage3 as v } from "../../pages/Rfp/validate";
import { Field, reduxForm } from "redux-form";
import AnonCompanyClientInfoForm from "./AnonCompanyClientInfoForm";

const mapStateToProps = state => {
  return {
    ...state.countries,
    ...state.industries,
  };
};

const mapDispatchToProps = {
  companyUnload,
  fetchCountries,
  fetchIndustries,
};

const Wrapper = ({ children, onClose }) => (
  <Modal>
    <div className="modal">
      <div
        className="modal-inner"
        style={{
          width: 1200,
          maxWidth: "90%",
        }}
      >
        <ButtonSpan className="m-3 absolute pin-t pin-r z-10" onClick={onClose}>
          <i className="fas fa-times-circle fa-2x ml-3" />
        </ButtonSpan>
        {children}
      </div>
    </div>
  </Modal>
);

const NewCompanyAndClientModal = ({
  title = "Create New Company",
  agencyId,
  fetchIndustries,
  token,
  fetchCountries,
  companyUnload,
  countries,
  industries,
  onClose,
  onSuccessRequest,
  isFetchingCountries,
  showNonSaveSwitch,
  enquiryId,
  onAnonSuccessRequest,
  isOneOffDetails = false,
}) => {
  const [companyDomains, setCompanyDomains] = useState();
  const [saveClientDetailsInEdge, setClientDetailsInEdge] = useState(1);
  useEffect(() => {
    agencyCompanyDomains(token, agencyId).then(response => {
      setCompanyDomains(response.result);
    });
    fetchCountries(token);
    fetchIndustries(token);
    return () => companyUnload();
  }, []);

  if (isFetchingCountries || Object.entries(countries).length === 0) {
    return <Loading />;
  }
  return (
    <Wrapper onClose={onClose}>
      <h1 className="mb-8">{title}</h1>
      <div className={"row"}>
        <div className="col col-w-full xl:col-w-full mb-2" >
          {isOneOffDetails ? <p>This will add the details for one-off use in this Confirmation export – your client details will not be saved.</p> : <p> This will save in your client database within EDGE - this RFP will be assigned, and statistics and exports will reference the company and client.</p>}

        </div>

      </div>
      {isOneOffDetails ? <AnonCompanyClientInfoForm
        company={{}}
        countries={countries ? countries : []}
        industries={industries}
        includeUserForm={true}
        agencyId={agencyId}
        fullWidth
        onSuccess={onAnonSuccessRequest}
        companyDomains={companyDomains}
        showNonSaveSwitch={showNonSaveSwitch}
        enquiryId={enquiryId}
      /> : <MinimalCompanyForm
        company={{}}
        countries={countries ? countries : []}
        industries={industries}
        includeUserForm={true}
        agencyId={agencyId}
        fullWidth
        onSuccess={onSuccessRequest}
        companyDomains={companyDomains}
        showNonSaveSwitch={showNonSaveSwitch}
        enquiryId={enquiryId}
      /> }

    </Wrapper>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewCompanyAndClientModal);
